module.exports = __webpack_public_path__ + "images/goals/MoveDealsForward.png";